import Img from "./img";

const Logo = ({ className }) => {
	return (
		<div className={`logo ${className || ""}`}>
			<Img
				alt="Sellwild Logo"
				className="sellwild-logo-lined light-icon same-color-border"
				src="/images/svg/sellwild-logo-GREEN.svg"
			/>
			<Img
				alt="Sellwild Logo"
				className="sellwild-logo-lined dark-icon same-color-border"
				src="/images/svg/sellwild-logo-WHITE.svg"
			/>
		</div>
	);
};

export default Logo;
